import { RentPlaceStatusEnum } from "../interfaces/rent-place.interface";

export const rentPlaceStatusOptions: { [key in RentPlaceStatusEnum]: string } = {
  [RentPlaceStatusEnum.RESERVED]: "Reservado",
  [RentPlaceStatusEnum.CONFIRMED]: "Confirmado",
  [RentPlaceStatusEnum.WAITING_LIST]: "Espera",
  [RentPlaceStatusEnum.CANCELED]: "Cancelado",
  [RentPlaceStatusEnum.PAID]: "Pagado",
};

export const placeOptions = [
  { label: "POLIDEPORTIVO", value: "POLIDEPORTIVO" },
  { label: "TEATRO", value: "TEATRO" },
];

export const statusColors: { [key: string]: string } = {
  "RESERVED": "#3f91dfff",       // Azul
  "CONFIRMED": "#1890ff",        // Azul más fuerte
  "WAITING_LIST": "#faad14",     // Amarillo/Naranja
  "CANCELED": "#f5222d",         // Rojo
  "PAID": "#52c41a",            // Verde
};

export const placeColors: { [key: string]: string } = {
  "POLIDEPORTIVO": "#87CEEB",    // Azul celeste
  "TEATRO": "#d491f6ff",         // Morado
};

// Helper function para verificar permisos por lugar
export const hasPlacePermission = (place: string, userPermissions: string[]): boolean => {
  if (!userPermissions || userPermissions.length === 0) return false;
  
  // Admin tiene todos los permisos
  if (userPermissions.includes('rent-places:admin')) return true;
  
  // Verificar permiso específico del lugar
  const placePermission = `rent-places:${place.toLowerCase()}`;
  return userPermissions.includes(placePermission);
};

// Helper function para obtener lugares permitidos para un usuario
export const getAllowedPlaces = (userPermissions: string[]): string[] => {
  if (!userPermissions || userPermissions.length === 0) return [];
  
  // Admin puede gestionar todos los lugares
  if (userPermissions.includes('rent-places:admin')) {
    return ['POLIDEPORTIVO', 'TEATRO'];
  }
  
  const allowedPlaces: string[] = [];
  if (userPermissions.includes('rent-places:polideportivo')) {
    allowedPlaces.push('POLIDEPORTIVO');
  }
  if (userPermissions.includes('rent-places:teatro')) {
    allowedPlaces.push('TEATRO');
  }
  
  return allowedPlaces;
};
